import React from "react";

export interface AuiIconProps {
  iconClass?: string;
  svgwidth?: string;
  svgheight?: any;
  onClick?: () => void; 
}

const AuiIcon: React.FC<AuiIconProps> = ({
  iconClass,
  onClick,
  svgwidth = "20",
  svgheight = "20",
}) => (
  <aui-icon
    svgclass={`aui-icon-${iconClass}`}
    className="actionIcon"
    pathclass={`aui-path-${iconClass}`}
    icon={iconClass}
    svgwidth={svgwidth}
    svgheight={svgheight}
    onClick={onClick}
  ></aui-icon>
);

export default AuiIcon;